<script>
  import Card from "../Card.svelte";

  export let article;

  const MAP = {
    // authorAndSource field created in utils.js/formatNews
    authorAndSource: { icon: "far fa-user-circle", tooltip: "Source" },
    tags: { icon: "far fa-tag", tooltip: "Tags" },
  };
</script>

<Card item={article} {MAP} />
